"use client";

import { useSession } from "next-auth/react";

export default function AuthDebug() {
  const { data: session, status } = useSession();

  if (status !== "authenticated" || !session?.user) {
    return null;
  }

  return (
    <section className="mx-auto my-4 max-w-6xl rounded-[4px] bg-white/95 p-3 font-['Stag_Sans',sans-serif] text-[var(--rtbf-dark,#001425)] shadow-[0px_2px_8px_rgba(0,0,0,0.12)]">
      <p className="mb-2 text-[14px] font-semibold uppercase tracking-wide">
        NextAuth user information
      </p>
      <pre className="max-h-[240px] overflow-auto whitespace-pre-wrap break-words rounded-[4px] bg-black/5 p-2 text-[11px] leading-snug">
        {JSON.stringify(
          {
            status,
            user: session.user,
            session,
          },
          null,
          2
        )}
      </pre>
    </section>
  );
}
